import { LearnerImportStatus } from './learner-import-status';
import { LearnerImportRowErrorDto, LearnerImportRowResultDto, LearnerImportSummaryDto } from './learner-import-summary.dto';

function getImportStatus(status: string): LearnerImportStatus | null {
    switch (status) {
        case 'created':
        case 'skipped':
        case 'failed':
            return status;

        default:
            return null;
    }
}

export class LearnerImportRowError {
    field: string;
    message: string;

    constructor(data: LearnerImportRowErrorDto) {
        this.field = data.field;
        this.message = data.message;
    }
}

export class LearnerImportRowResult {
    row: number;
    email: string;
    status: LearnerImportStatus | null;
    userId: string | null;
    existingUserId: string | null;
    reason: string | null;
    errors: LearnerImportRowError[];

    constructor(data: LearnerImportRowResultDto) {
        this.row = data.row;
        this.email = data.email;
        this.status = getImportStatus(data.status);
        this.userId = data.userId ?? null;
        this.existingUserId = data.existingUserId ?? null;
        this.reason = data.reason ?? null;
        this.errors = (data.errors ?? []).map((error) => new LearnerImportRowError(error));
    }
}

export class LearnerImportSummary {
    totalRows: number;
    created: number;
    skipped: number;
    failed: number;
    results: LearnerImportRowResult[];

    constructor(data: LearnerImportSummaryDto) {
        this.totalRows = data.totalRows;
        this.created = data.created;
        this.skipped = data.skipped;
        this.failed = data.failed;
        this.results = (data.results ?? []).map((result) => new LearnerImportRowResult(result));
    }
}
